import React from "react";
import classnames from "classnames";
import PropTypes from "prop-types";

import Select from "../Select/Select";

import "./telephone-field.scss";

const TelephoneField = ({
  id,
  countryCode,
  countryCodes,
  telephone,
  disabled,
  className,
  placeholder,
  onCountryCodeChange,
  onTelephoneChange,
  onTelephoneBlur,
  name,
  required,
}) => {
  const classes = classnames("telephone-field", className);
  return (
    <div className={classes}>
      <Select
        id={`${id}-country-code`}
        className="telephone-field__country-code"
        options={countryCodes}
        disabled={disabled}
        onChange={value => onCountryCodeChange(value)}
        hasJumpList
        placeholder={placeholder}
        value={countryCode}
        isCountryCode
      />
      <input
        id={`${id}-input`}
        className="telephone-field__tel"
        type="tel"
        name={name}
        disabled={disabled}
        placeholder={placeholder}
        value={telephone}
        onChange={e => onTelephoneChange(e.target.value)}
        onBlur={onTelephoneBlur}
        required={required}
      />
    </div>
  );
};

TelephoneField.propTypes = {
  id: PropTypes.string.isRequired,
  countryCode: PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string,
  }),
  countryCodes: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      label: PropTypes.string,
      options: PropTypes.arrayOf(PropTypes.shape({})),
    })
  ).isRequired,
  telephone: PropTypes.string,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  placeholder: PropTypes.string,
  onCountryCodeChange: PropTypes.func.isRequired,
  onTelephoneChange: PropTypes.func.isRequired,
  onTelephoneBlur: PropTypes.func,
  name: PropTypes.string,
  required: PropTypes.bool,
};

TelephoneField.defaultProps = {};

export default TelephoneField;
